import { ServiceFieldType } from '@onlog-public/additional-services-types';
import {
  OptionsCache,
  optionLoaderProcessor,
} from '@pages/AdditionalServices/containers/services/optionsLoader/types';
import { ecoFeeLoader } from '@services/requests/searchLoaders/ecoFeeLoader';
import { EcoFeeProductsLoaderResponse } from '@services/requests/searchLoaders/ecoFeeLoader/EcoFeeProductsLoaderQuery';

/**
 * EcoFeeProductProcessor реализует процессор для загрузки товаров экосбора
 */
export class EcoFeeProductProcessor implements optionLoaderProcessor {
  /**
   * GetType возвращает тип поля, для которого собран процессор
   */
  GetType(): ServiceFieldType {
    return 'product';
  }

  /**
   * LoadOptionsCache выполняет загрузку кэша определенного типа
   * В качестве аргумента принимает тип поля и идентификаторы для загрузки.
   *
   * @param id
   */
  async LoadOptionsCache(id?: string[]): Promise<OptionsCache<any>> {
    if (!id) {
      return { isPartialLoading: true, cache: {} };
    }

    const cache: OptionsCache<EcoFeeProductsLoaderResponse['items'][number]> = {
      isPartialLoading: true,
      cache: {},
    };

    if (id.length === 0) {
      return cache;
    }
    const versions = await ecoFeeLoader().LoadProductsByParams({ where: { id: { _in: id } } });
    versions.map((v) => (cache.cache[v.id] = v));

    return cache;
  }
}
